import { STATUS } from '@kontentino/kontentino-constants/Posts';
import type { TFunction } from 'i18next';

export const getPostFooterInfoMessage = (input: {
  status: number;
  message?: string;
  t: TFunction;
}) => {
  if (!input.message) {
    switch (input.status) {
      case STATUS.IS_SCHEDULING:
        return input.t('postFooterInfo.isScheduling');
      case STATUS.AT_CLIENT:
        return input.t('postFooterInfo.atClient');
      case STATUS.EXPORT_FAILED:
        return input.t('postFooterInfo.exportFailed');
      default:
        return '';
    }
  }

  return input.message;
};
